import { ColumnType, SortDirection } from "../models/generic";
import { ISColumn } from "./is-table";

/**
 * @description Filter the array by the string
 * @param  {any[]} array
 * @param  {string} string
 */
export function filterContainsByValue<T>(array: any[], string: string, key: string) {
    let arrayFiltered: T[] = array.filter(item => item[key].toString().toLowerCase().includes(string.toLowerCase()));
    return arrayFiltered;
}

/**
 * @description Filter the array by the date
 * @param  {any[]} array
 * @param  {Date} date
 * @param  {string} key - DB column to compare with date
 */
export function filterByDate<T>(array: any[], date: Date, key: string) {
    let arrayFiltered: T[] = array.filter(item => isDateEqual(new Date(item[key]), date));
    return arrayFiltered;
}

/**
 * @description Filter the array between dates
 * @param  {any[]} array
 * @param  {Date} start
 * @param  {Date} end
 * @param  {string} key - DB column to compare with date
 */
export function filterBetweendDates<T>(array: any[], start: Date, end: Date, key: string) {
    end.setHours(end.getHours() + 23);
    end.setMinutes(end.getMinutes() + 59);
    end.setSeconds(end.getSeconds() + 59);

    let arrayFiltered: T[] = array.filter(item => {
        const date = new Date(item[key]);
        return date >= start && date <= end;
    })
    /*let arrayFiltered: T[] = array.filter(item => {
        const [day, month, year] = item[key].split('/');
        const date = new Date(+year, +month - 1, +day);
        return date >= start && date <= end;
    })*/
    return arrayFiltered;
}

/**
 * @description Compares if two dates are equal
 * @param  {Date} date1 - first date
 * @param  {Date} date2 - second date
 */
export function isDateEqual(date1: Date, date2: Date) {
    return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
    );
}

/**
 * @description Order the array by the column
 * @param  {any[]} array - Array to be ordered
 * @param  {ISColumn} column - Column to be ordered
 */
export function sortByColumn<T>(array: any[], column: ISColumn) {
    let arraySorted: T[] = array;
    if (column.type === 'number') arraySorted = array.sort((n1, n2) => n1 - n2);

    arraySorted = array.sort((a: any, b: any) => {

        if (column.type != ColumnType.number) {
            return a[column.identifier].localeCompare(b[column.identifier])

        } else {
            if (a[column.identifier] > b[column.identifier]) {
                return 1;
            }

            if (a[column.identifier] < b[column.identifier]) {
                return -1;
            }
        }
        return 0;
    });

    if (column.direction === SortDirection.desc) arraySorted.reverse();
    return arraySorted;
}